import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["date", "label"];
import React, { useRef } from 'react';
import { cnBem } from '@carnica/utils';
import { useComponentSize, useManyRefs } from '@carnica/utils/hooks';
import { motion } from 'framer-motion';
import { isSameYear } from 'date-fns-new';
import { useYearsScroll } from "../../hooks/useYearsScroll";
import { Cell } from "../../Cell";
import styles from "./styles.pcss";
import { Grid } from "../../Grid";
import { useDatePeriodList } from "../../hooks/useDatePeriodList";
var cnCalendarBlockYear = cnBem('years-block', styles);
export var CalendarBlockYear = function CalendarBlockYear(props) {
  var currentVisibleDate = props.currentVisibleDate,
    setCurrentVisibleDate = props.setCurrentVisibleDate,
    minDate = props.minDate,
    maxDate = props.maxDate,
    locale = props.locale,
    disableDates = props.disableDates,
    changeMode = props.changeMode;
  var containerRef = useRef(null);
  var _useComponentSize = useComponentSize(containerRef),
    height = _useComponentSize.height;
  var onKeyDown = function onKeyDown(e) {
    if (e.code === 'Escape') {
      changeMode === null || changeMode === void 0 ? void 0 : changeMode();
    }
  };
  var onYearChoose = function onYearChoose(date) {
    if (!date) {
      return;
    }
    setCurrentVisibleDate === null || setCurrentVisibleDate === void 0 ? void 0 : setCurrentVisibleDate(date);
    changeMode === null || changeMode === void 0 ? void 0 : changeMode();
  };
  var years = useDatePeriodList({
    onChange: onYearChoose,
    type: 'years',
    locale: locale,
    currentVisibleDate: currentVisibleDate,
    disableDates: disableDates,
    maxDate: maxDate,
    minDate: minDate
  });
  var refs = useManyRefs(years.length);
  useYearsScroll({
    containerRef: containerRef,
    currentVisibleDate: currentVisibleDate,
    isActive: true,
    refs: refs
  });
  return /*#__PURE__*/React.createElement(motion.div, {
    className: cnCalendarBlockYear(),
    onKeyDown: onKeyDown,
    ref: containerRef,
    style: _defineProperty({}, '--wrapper-size', "".concat(height || 438, "px"))
  }, /*#__PURE__*/React.createElement(Grid, {
    className: cnCalendarBlockYear('list'),
    type: "years",
    "data-t-id": "CalendarBlocks-CalendarBlockYear"
  }, years.map(function (_ref2, i) {
    var date = _ref2.date,
      label = _ref2.label,
      params = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/React.createElement(Cell, _extends({
      "aria-label": "".concat(label, " \u0433\u043E\u0434"),
      key: date.toDateString(),
      ref: refs[i],
      rootProps: {
        className: cnCalendarBlockYear('year')
      },
      size: "m",
      view: isSameYear(currentVisibleDate, date) ? 'selected' : 'default'
    }, params), label);
  })));
};